import React from "react";
import Tabla from "js/pages/Unilever/Med/VariablesMed/Tabla";

export const VariablesMed = props => {
  return (
    <div>
      <Tabla {...props} />
    </div>
  );
};

export default VariablesMed;
